import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { Observable } from 'rxjs';

import { Endpoint, EndpointService } from '../endpoints';
import { ILocale, IUtilsServiceData } from './utils.models';

@Injectable({
	providedIn: 'root'
})
export class UtilsService {
	public data: IUtilsServiceData = {
		locales: {}
	};

	constructor(@Inject(LOCALE_ID) protected locale: string, private http: HttpClient, private endpointService: EndpointService) {}

	public clearCache(): void {
		this.data.locales = {};
	}

	public getLocales(locale = this.locale, force = false): Observable<ILocale[]> {
		const url = `${this.endpointService.url(Endpoint.termLocales)}?locale=${locale}`;

		return new Observable<ILocale[]>((observer) => {
			if (force || !this.data.locales[locale] || this.data.locales[locale].length === 0) {
				this.http.get<ILocale[]>(url).subscribe(
					(res: ILocale[]) => {
						this.data.locales[locale] = res;
						observer.next(this.data.locales[locale]);
						observer.complete();
					},
					(error: any) => {
						observer.error(error);
						observer.complete();
					}
				);
			} else {
				observer.next(this.data.locales[locale]);
				observer.complete();
			}
		});
	}
}
